import { useState } from "react";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Navbar from "scenes/widgets/navbar";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [feedback, setFeedback] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setFeedback(null);
    try {
      const response = await fetch(`${BASE_URL}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || "Anfrage fehlgeschlagen.");
      }
      setFeedback({
        severity: "success",
        text:
          data.message ||
          "Falls ein Konto mit dieser E-Mail existiert, wurde ein Link zum Zurücksetzen gesendet.",
      });
    } catch (error) {
      setFeedback({
        severity: "error",
        text: error.message || "Anfrage fehlgeschlagen.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box>
      <Navbar />
      <Box maxWidth="560px" mx="auto" mt="2rem" p="2rem">
        <Typography variant="h4" mb="1rem">
          Passwort vergessen
        </Typography>
        {feedback && (
          <Alert severity={feedback.severity} sx={{ mb: "1rem" }}>
            {feedback.text}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="E-Mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            sx={{ mt: "1rem", mr: "0.5rem" }}
            disabled={isSubmitting}
          >
            Link senden
          </Button>
          <Button component={RouterLink} to="/einloggen" sx={{ mt: "1rem" }}>
            Zurück zum Login
          </Button>
        </form>
      </Box>
    </Box>
  );
};

export default ForgotPasswordPage;

